import * as _ from 'lodash';
import * as React from 'react';
import AsyncSelect from 'react-select/lib/Async';
import { Styles } from 'react-select/lib/styles';
import { Param } from '../../../../api-entities/Param';
import { TApiParameter } from '../../../../api/endpoints/Parameter';
import ParamLabel from '../../../ParamLabel';
import { ValueType } from "react-select/lib/types";

const colourStyles: Partial<Styles> = {
  control: styles => ({ ...styles, backgroundColor: 'white', borderColor: '#d6d6d6' }),
  dropdownIndicator: styles => ({ ...styles, color: 'black' }),
  indicatorSeparator: styles => ({ ...styles, backgroundColor: 'transparent' })
};

const getFilteredParams = _.debounce(
  (resolve: (value: TApiParameter[]) => void, text: string, options: Param[]) => {
    text = text.toLowerCase();
    resolve(
      options.filter(
        p =>
          p.id.toString().includes(text) ||
          p.name.toLowerCase().includes(text) ||
          p.shortname.toLowerCase().includes(text)
      )
    );
  },
  250
);

const isArray = (value: ValueType<TApiParameter>): value is ReadonlyArray<TApiParameter> => {
  return Array.isArray(value);
}

const castValue = (value: ValueType<TApiParameter>): Array<TApiParameter> => {
  if (isArray(value)) {
    return [...value];
  } else if (!value) {
    return [];
  } else {
    return [value];
  }
}

type TProps = {
  params: Array<TApiParameter>;
  value: Array<TApiParameter>;
  onChange: (params: Array<TApiParameter>) => void;
  isMulti?: boolean;
}

/**
 * A control for selecting parameters to filter the set of available subsets.
 */
const ParamSearch = (props: TProps) => {
  const { params, value, onChange, isMulti } = props;

  const promiseOptions = (inputValue: string) =>
    new Promise(resolve => getFilteredParams(resolve, inputValue, params));

  const onSelectChange = (value: ValueType<TApiParameter>) => {
    const castedValue = castValue(value);

    onChange(castedValue);
  }

  return (
    <div className="param-search">
      <label className="control-label" htmlFor="param-search">
        Search by parameter
      </label>

      <AsyncSelect<TApiParameter>
        isMulti={isMulti}
        isClearable
        formatOptionLabel={p => <ParamLabel param={p} placement="bottom" />}
        getOptionValue={p => p.shortname}
        value={value}
        loadOptions={promiseOptions}
        placeholder="Enter a search query"
        noOptionsMessage={() => 'No options match your query.'}
        onChange={onSelectChange}
        styles={colourStyles}
      />
    </div>
  );
};

export default ParamSearch;
